import { Button } from '@/components/ui/button';
import { Modal } from '@/components/ui/modal';
import { useImportDeviceMutation } from '@/redux/api/endpoints/device-import';
import { AlexaDevice } from '@/types/device';

type ConfirmImportDevicesModalProps = {
  isOpen: boolean;
  onCancel: () => void;
  onComplete: () => void;
  selectedDevices: AlexaDevice[];
};

export default function ConfirmImportDevicesModal({
  isOpen,
  onCancel,
  onComplete,
  selectedDevices = [],
}: ConfirmImportDevicesModalProps) {
  const [importDevice, { isLoading }] = useImportDeviceMutation();

  const handleImport = async () => {
    try {
      await Promise.all(
        selectedDevices.map((device) =>
          importDevice({
            type: 'ALEXA',
            deviceEndpoint: device.endpointId,
          }),
        ),
      );
      onComplete();
    } catch (error) {
      console.error('Error importing devices:', error);
    }
  };

  return (
    <Modal
      buttonItems={[
        <Button key="cancel" onClick={onCancel} variant="secondary">
          Cancel
        </Button>,
        <Button
          disabled={isLoading}
          key="confirm"
          onClick={handleImport}
          variant="primary"
        >
          {isLoading ? 'Importing...' : 'Import Devices'}
        </Button>,
      ]}
      open={isOpen}
      setOpen={onCancel}
      title="Confirm Import"
    >
      <div>
        <p>Are you sure you want to import the following devices?</p>
        <div className="mt-4 rounded-md bg-gray-50 p-3">
          <p className="font-semibold">
            Selected Devices: {selectedDevices.length}
          </p>
          {selectedDevices.length > 0 && (
            <ul className="mt-2 max-h-40 overflow-auto">
              {selectedDevices.map((device) => (
                <li className="text-sm" key={device.endpointId}>
                  {device.friendlyName || device.serialNumber}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </Modal>
  );
}
